"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockArticle = void 0;
const Article_1 = require("./Article");
const echain_shared_oo_1 = require("@igus/echain-shared-oo");
class MockArticle extends Article_1.Article {
    constructor(id) {
        super({
            ArticleType: 'MockArticle',
            EntityId: echain_shared_oo_1.UUIDGenerator.new(),
            Id: id,
        });
        this.className = 'MockArticle';
        this.id = id;
    }
    clone() {
        const article = new MockArticle();
        article.fromJson(this.toJson());
        return article;
    }
    duplicate() {
        const article = new MockArticle();
        const json = this.toJson();
        delete json.EntityId;
        article.fromJson(json);
        return article;
    }
}
exports.MockArticle = MockArticle;
//# sourceMappingURL=MockArticle.js.map